import { createRoot } from 'react-dom/client';
import { ReactElement } from 'react';

export function renderToBody(element: ReactElement) {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = createRoot(container);
  function unmount() {
    root.unmount();
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  }
  root.render(element);
  return unmount;
}
